import { createSelector } from '@reduxjs/toolkit';
import { dexTokenMapApi, dexTokenMapApiEndpoints } from '@skynet/data-dex-token-map';
import type { LoanBindingItem } from '@skynet/data-dex-token-map';

export interface Store {
  [dexTokenMapApi.reducerPath]: ReturnType<typeof dexTokenMapApi.reducer>;
}

const selectTokenApi = createSelector(
  (state: Store) => state,
  (tokenMapResult) => dexTokenMapApiEndpoints.getTokenMap.select()(tokenMapResult),
);

export const selectTokenMapData = createSelector(selectTokenApi, (tokenMapResult) => {
  if (tokenMapResult?.data) {
    return tokenMapResult.data.data.reduce((acc: Record<string, string>, item: LoanBindingItem) => {
      acc[item.symbol] = item.label;
      return acc;
    }, {});
  }
  return {};
});
